
import { defineComponent } from "vue-demi";
import ServicesData from "@/modules/Pricing/Services/servicesData.json";
import { SMAdditionalInfo } from "@/store";
import { track } from "@amplitude/analytics-browser";

export default defineComponent({
  name: "Services",

  components: {
    ServicesBlock: () => import("@/modules/Pricing/Services/ServicesBlock.vue"),
    PricingServicesPopups: () => import("@/modules/Pricing/Services/PricingServicesPopups.vue"),
  },

  setup() {
    const servicesData = ServicesData;

    function onServiceClick(service: "cos_allocation" | "mock_audit" | "paid_consultation") {
      SMAdditionalInfo.openPricinServicePopop(service);

      track("Clicked 'Learn More' on a pricing page [Services]", { service });
    }

    return {
      servicesData,
      onServiceClick,
    };
  },
});
